import { useEffect, useState } from 'react';
import { switchRegionBaseUrl } from '../utils/httpUtils';
import { baseURL } from '../data/Config';

const useBaseUrl = (region: string) => {
  // 최초 렌더에서 region을 기반으로 초기 URL 계산 (없으면 기존 기본값)
  const [baseUrl, setBaseUrl] = useState(
    () => switchRegionBaseUrl(region) || baseURL
  );

  useEffect(() => {
    const next = switchRegionBaseUrl(region) || baseURL;
    // 값이 실제로 바뀌는 경우에만 setState -> StrictMode의 이펙트 2회 호출에도 중복 업데이트 방지
    if (next !== baseUrl) {
      setBaseUrl(next);
    }
  }, [region, baseUrl]);

  return baseUrl;
};

export default useBaseUrl;
